import type { CSSProperties, HTMLAttributes } from "react";

export type SkeletonVariant = "text" | "block" | "circle";

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: SkeletonVariant;
  width?: number | string;
  height?: number | string;
  size?: number | string;
}

export function Skeleton({
  variant = "text",
  width,
  height,
  size,
  className,
  style,
  ...rest
}: SkeletonProps) {
  const resolved: CSSProperties = { ...style };
  if (variant === "circle") {
    const dim = size ?? width ?? 32;
    resolved.width = dim;
    resolved.height = dim;
  } else {
    if (width !== undefined) resolved.width = width;
    if (height !== undefined) resolved.height = height;
  }
  return (
    <div
      {...rest}
      aria-hidden="true"
      className={["rp-skel", `rp-skel--${variant}`, className]
        .filter(Boolean)
        .join(" ")}
      style={resolved}
    />
  );
}
